import { render, staticRenderFns } from "./RentalRates.vue?vue&type=template&id=6756956e&scoped=true"
import script from "./RentalRates.vue?vue&type=script&lang=js"
export * from "./RentalRates.vue?vue&type=script&lang=js"
import style0 from "./RentalRates.vue?vue&type=style&index=0&id=6756956e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6756956e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6756956e')) {
      api.createRecord('6756956e', component.options)
    } else {
      api.reload('6756956e', component.options)
    }
    module.hot.accept("./RentalRates.vue?vue&type=template&id=6756956e&scoped=true", function () {
      api.rerender('6756956e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/dialogs/dialog_rental_rates/RentalRates.vue"
export default component.exports